export default "__VITE_ASSET__DK0NaZe8__"